// @flow

import { useSelector } from "react-redux";
import { ButtonLink } from "@nested/component-library";

export const BookIntroCall = ({
  className,
  size = "medium",
}: {
  className?: string,
  size?: string,
}) => {
  // The results page can be accessed without having gone through
  // onboarding; so don't try and send someone who's been
  // forwarded a link straight into the calendar
  const hasRequestedValuationAlready = useSelector((state) =>
    Boolean(state.onboardingForm?.avmValuationId),
  );

  return (
    <ButtonLink
      data-test="personal-valuation:book-a-call"
      type="pink"
      size={size}
      className={className}
      to={
        hasRequestedValuationAlready
          ? "/get-started/personal-valuation"
          : "/get-started"
      }
    >
      Book a call
    </ButtonLink>
  );
};
